import axios from 'axios'

const directionsApi =  axios.create({
    baseURL : 'https://api.mapbox.com/directions/v5/mapbox/driving',
    params: {
        alternatives: false,
        geometries: 'geojson',
        overview: 'simplified',
        steps: false,
        access_token: 'pk.eyJ1Ijoib3NjYXJmcGF0YSIsImEiOiJjbGRxN2dkNDgwMTVkM29rZ2ZzNzFmY3A0In0.P3iRtuCzBq2opwTqrD8YQg'

    }

})

export default directionsApi